import React from 'react'

import { useHasPermissionV2 } from './hooks/useHasPermissionV2'

interface PermissionAccessGuardProps {
    permission: string
    children: React.ReactNode
};

const PermissionAccessGuard = ({ permission, children }: PermissionAccessGuardProps) => {
    const state = useHasPermissionV2(permission);

    if (state === 'loading')  return null; // quietly wait — no false flash, no wrong state
    if (state === 'denied')   return null; // no permission — hide element
    return <>{children}</>;               // permitted — show element
}

export default PermissionAccessGuard;